<template>
    <div class="passwordPop" v-if="passwordPop.isPassword" >
        <!--密码登录弹框-->
        <div class="pub_pop">
            <div class="pop_container">
                <form class="passwordForm">
                    <ul class="tabBox">
                        <li :class="{active: isWay == 'password'}" @click="isWay = 'password'">密码登录</li>
                        <li :class="{active: isWay == 'note'}" @click="isWay = 'note'">快捷登录</li>
                    </ul>
                    <div class="contentBox">
                        <div class="group">
                            <input type="number" class="group_control" placeholder="请输入手机号码" onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))" v-model.trim="phone" >
                        </div>

                        <div  v-if="isWay == 'password'">
                            <div class="group">
                                <input type="password" class="group_control" placeholder="请输入密码" v-model.trim="passwords">
<!--                                <i class="icon_eye"></i>-->
                            </div>
                        </div>
                        <div v-if="isWay == 'note'">
                            <div class="group">
                                <input type="number" class="group_control" onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))" placeholder="请输入验证码" v-model.trim="smscode">
                                <div class="getCode" @click="getCode($event)">获取验证码</div>
                            </div>
                        </div>
                    </div>
                    <div class="txtBox">
                        <!-- <a class="forget"><a href="/register">立即注册</a></p> -->
<!--                        <p class="forget"><a href="/getpass">忘记密码?</a></p>-->
                    </div>
                    <div class="login_btns">
                        <div class="login_btn btn quick_btn" @click="subQuick">立即登录</div>
                    </div>
                </form>
                <div class="icon_black" @click="passwordPop.isPassword = false"></div>
            </div>
        </div>
    </div>
</template>

<script>

    //1、引入组件
    // import PasswordPop from '../../../components/passwordPop/passwordPop.vue'
    //2、注册组件
    // components: {
    //     PasswordPop,
    // },
    // 3、调用组件
    // <PasswordPop ref="mychild" :passwordPop="passwordPop"></PasswordPop>
    // (1)ref="mychild"     父组件调用子组件方法
    //     栗子：
    //         submits(){
                    //判断是否登录了
    //             this.$refs.mychild.getIsLogin()
    //         },
    // (2) //子组件调用的方法   父组件必须有定义这个方法不然报错（可以为空方法）
           //无奈之举以备不时之需，
    //      getOrderShow(){
    //          执行代码
    //      },
    // 4、子组件接收父组件的对象参数
    // passwordPop:{                  //父组件对象
    //     isPassword: false,         //是否显示弹框
    //         type: 'sanfang',       //类型  sanfang //执行父组件方法，next登录完成进入下一页
    //         getUrl: '',            //登录完成跳转路径
    //         zkhBay:'',             //保存number
    // },
    export default {
        name: "passwordPop",
        data:()=>{
            return {
                isWay:'password',
                smscode: '',                   //短信
                phone:'',                     //手机号
                passwords:"",                 //密码
            }
        },
        props:{
            passwordPop:Object
        },
        methods:{
            //判断是否登录
            getIsLogin(){
                let _this = this;
                //是否登录
                $.ajax({
                    url:"https://m.zuke.com/mapi/home/public",
                    type:"post",
                    data:{},
                    success:function(res){
                        if(res.code == 10000){
                            if(res.data.memberNumber){

                                if(_this.$publicObj.getCookie('member_pass')){
                                    if(_this.passwordPop.type == 'next' || _this.passwordPop.type == 'job'){
                                        location.href = _this.passwordPop.getUrl
                                    }
                                }else if (_this.$store.state.cookies.is_login == 1){
                                    if(_this.passwordPop.type == 'next' || _this.passwordPop.type == 'job'){
                                        location.href = _this.passwordPop.getUrl
                                    }
                                } else{
                                    _this.passwordPop.isPassword = true
                                }

                            }else{

                                if(_this.$publicObj.getCookie('is_login') ==1){
                                    if(_this.passwordPop.type == 'next' || _this.passwordPop.type == 'job'){
                                        location.href = _this.passwordPop.getUrl
                                    }
                                }else if (_this.$store.state.cookies.is_login == 1){
                                    if(_this.passwordPop.type == 'next' || _this.passwordPop.type == 'job'){
                                        location.href = _this.passwordPop.getUrl
                                    }
                                }else{
                                    _this.passwordPop.isPassword = true
                                }
                            }
                        }else{
                            _this.layerFun(res.message)
                        }
                    },
                    error:function(err){
                        console.log(err)
                    }
                })
            },

            //调用父组件方法
            childMethod(){
                if (this.passwordPop.type == 'sanfang' || this.passwordPop.type == 'jobs'){
                    this.$parent.getOrderShow();
                }
            },
            // 获取验证码
            getCode(event){

                if($('.getCode').hasClass('active')){
                    return false;
                }else{
                    var _this = this;
                    var sendsmsData = _this.$publicObj.getSign('/register/sendsms',{
                        version:1.2,
                        phone:_this.phone
                    },_this.$store.state)
                    $.ajax({
                        url:'https://japiv2.zuke.com/register/sendsms',
                        type:'post',
                        data:sendsmsData,
                        beforeSend:function(){
                            $('.getCode').addClass('active')
                        },
                        success:function(res){
                            if(res.code==10000){
                                _this.$publicObj.codeTime($('.getCode'));
                                _this.$publicObj.layerFun('发送成功，请注意查收')
                            }else{
                                _this.$publicObj.layerFun(res.message)
                            }
                        },
                        error:function(err){
                            _this.$publicObj.layerFun('出错了，请联系工作人员');
                        }
                    })
                }
            },
            // 快捷注册
            subQuick(){
                var _this = this;

                let quickData;
                let getUrl;
                var regPhone = /^1[3456789]\d{9}$/; //手机号码
                var regSms = /^\d{6}$/;//验证码
                var m = _this.$publicObj.getQueryString('m');
                if(_this.phone==''|| !regPhone.test(_this.phone)){
                    _this.$publicObj.layerFun('请输入正确的手机号');
                    return false;
                }

                if (_this.isWay == 'note'){
                    if(_this.smscode==''|| !regSms.test(_this.smscode)){
                        _this.$publicObj.layerFun('请输入正确验证码');
                        return false;
                    }
                    getUrl = '/register/quick';

                    let quickObj = {
                        version:1.2,
                        phone:_this.phone,
                        smscode:_this.smscode,
                        source:'baike'
                    };
                    quickData = _this.$publicObj.getSign('/register/quick',quickObj,_this.$store.state)
                }else {
                    if(_this.passwords == ''){
                        _this.$publicObj.layerFun('请输入密码');
                        return false;
                    }
                    getUrl = '/login/pwd'
                    quickData = _this.$publicObj.getSign('/login/pwd',{
                        version:1.2,
                        phone: _this.phone,
                        passwd: _this.passwords
                    },_this.$store.state)
                }

                $.ajax({
                    url:'https://japiv2.zuke.com'+getUrl,
                    type:'post',
                    data: quickData,
                    success:function(res){

                        if(res.code==10000){
                            _this.$publicObj.layerFun('登陆成功')
                            // 设置cookie
                            _this.$publicObj.setCookie('member_id',res.data.number)
                            _this.$publicObj.setCookie('member_pass',res.data.token)
                            _this.$publicObj.setCookie('is_login',1);

                            _this.$store.state.cookies.member_id = res.data.number;
                            _this.$store.state.cookies.member_pass = res.data.token;
                            _this.$store.state.cookies.is_login = 1;
                            // console.log(res.data.is_complete)
                            _this.passwordPop.isPassword = false;

                            //租客惠付款请求数据
                            if (_this.passwordPop.type == 'sanfang' || _this.passwordPop.type == 'jobs'){
                                _this.childMethod()
                                _this.passwordPop.zkhBay = res.data.number
                                return
                            }
                            if(_this.passwordPop.type == 'next' || _this.passwordPop.type == 'job'){
                                location.href = _this.passwordPop.getUrl
                                return
                            }
                        }else{
                            _this.$publicObj.layerFun(res.message);
                        }
                    },
                    error:function(err){
                        _this.$publicObj.layerFun('出错了，请联系工作人员');
                    }
                })
            }
        },

    }
</script>

<style lang="less" scoped>

    .passwordPop {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 200;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }
    .passwordPop .pop_container {
        position: absolute;
        width: 80%;
        top: 50%;
        left: 50%;
        max-width: 16rem;
        min-width: 8rem;
        transform: translate(-50%, -50%);
        -webkit-border-radius: 0.4rem;
        -moz-border-radius: 0.4rem;
        -ms-border-radius: 0.4rem;
        -o-border-radius: 0.4rem;
        border-radius: 0.4rem;
        background-color: #fff;
    }
    .passwordPop .passwordForm {
        padding: .95rem 1.25rem 1rem;
    }
    .passwordPop .passwordForm ul.tabBox {
        display: -webkit-flex;
        display: flex;
        justify-content: space-around;
    }
    .passwordPop .passwordForm ul.tabBox li {
        padding-bottom: .45rem;
        font-weight: normal;
        line-height: 1;
        font-size: .7rem;
        color: #333;
    }
    .passwordPop .passwordForm ul.tabBox li.active {
        color: #5CB4FB;
        border-bottom: 2px solid #5CB4FB;
    }
    .passwordPop .showcontent {
        display: none;
    }
    .passwordPop .showcontent.active {
        display: block;
    }
    .passwordPop .getCode {
        cursor: pointer;
        width: 50%;
        font-size: .5rem;
        color: #3FABFA;
        text-align: right;
    }
    .passwordPop .passwordForm .group {
        display: -webkit-flex;
        display: flex;
        align-items: center;
        margin-top: .75rem;
        padding: 0  .9rem;
        // width: 100%;
        border: 1px solid #ccc;
        -webkit-border-radius: 0.3rem;
        -moz-border-radius: 0.3rem;
        -ms-border-radius: 0.3rem;
        -o-border-radius: 0.3rem;
        border-radius: 0.3rem;
        overflow: hidden;
    }
    .passwordPop .passwordForm .group .group_control {
        padding: .375rem 0;
        width: 100%;
        font-size: 0.6rem;
        color: #333;
        border: 0;
    }
    .passwordPop .passwordForm .txtBox {
        display: -webkit-flex;
        display: flex;
        justify-content: space-between;
    }
    .passwordPop .passwordForm p.forget {
        padding-top: .675rem;
        font-size: 0.55rem;
        color: #5CB4FB;
    }
    .passwordPop .passwordForm .login_btns {
        padding-top: 0.9rem;
    }
    .passwordPop .passwordForm .login_btns .btn {
        cursor: pointer;
        width: 100%;
        height: 1.45rem;
        font-size: 0.7rem;
        line-height: 1.45rem;
        text-align: center;
        color: #fff;
        background-color: #3FABFA;
        -webkit-border-radius: 0.3rem;
        -moz-border-radius: 0.3rem;
        -ms-border-radius: 0.3rem;
        -o-border-radius: 0.3rem;
        border-radius: 0.3rem;
    }
    .passwordPop .icon_black {
        position: absolute;
        bottom: -2rem;
        left: 50%;
        transform: translateX(-50%);
        width: 1.2rem;
        height: 1.2rem;
        background: url('../../assets/images/cross-black-bg.png') center center / 100% 100% no-repeat;
    }
</style>



// WEBPACK FOOTER //
// passwordPop.vue